/**
 * Instant Add-to-Cart Handler
 * Handles buttons with data-instant-add="true" attribute
 * Works with card.liquid and any other templates using the same pattern
 */

(function() {
  'use strict';

  // Debounce to prevent multiple initializations
  let initialized = false;

  function initInstantAdd() {
    if (initialized) return;
    initialized = true;

    // Use event delegation on document for dynamic content
    document.addEventListener('click', handleInstantAddClick, true);
    
    console.log('✅ Instant add-to-cart initialized');
  }

  function handleInstantAddClick(e) {
    const btn = e.target.closest('[data-instant-add="true"]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const variantId = btn.dataset.variantId;
    if (!variantId) {
      console.error('No variant ID found on instant-add button');
      return;
    }

    addToCartInstantly(btn, variantId);
  }

  async function addToCartInstantly(btn, variantId) {
    // Prevent double clicks
    if (btn.classList.contains('loading')) {
      return;
    }

    const labelEl = btn.querySelector('.card__button-label, .ai-button-label, [class*="button-label"]');
    const originalContent = labelEl ? labelEl.textContent : '';

    try {
      btn.classList.add('loading');
      btn.disabled = true;
      if (labelEl) labelEl.textContent = 'Додаємо...';

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId),
            quantity: 1
          }]
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      const data = await response.json();

      // Success feedback
      if (labelEl) labelEl.textContent = 'Додано ✓';
      btn.classList.remove('loading');
      btn.classList.add('added');

      // Update cart counter
      updateCartCounter();

      // Open cart drawer
      openCartDrawer();

      // Dispatch events for theme integration
      document.dispatchEvent(new CustomEvent('cart:item-added', {
        detail: { items: data.items }
      }));

      // Trigger theme's pubsub if available
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'instant-add', cart: data });
      }

      // Reset button after delay
      setTimeout(() => {
        if (labelEl) labelEl.textContent = originalContent;
        btn.classList.remove('added');
        btn.disabled = false;
      }, 1500);

    } catch (error) {
      console.error('Add to cart error:', error);
      if (labelEl) labelEl.textContent = 'Помилка';

      setTimeout(() => {
        if (labelEl) labelEl.textContent = originalContent;
        btn.classList.remove('loading');
        btn.disabled = false;
      }, 2000);
    }
  }

  async function updateCartCounter() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      // Update common cart counter selectors
      const counters = document.querySelectorAll(
        '.cart-count, .cart-item-count, [data-cart-count], .js-cart-count, ' +
        '.header__cart-count, .site-header__cart-count, .cart-count-bubble span, ' +
        '#cart-icon-bubble span, .cart__count, #CartDrawer-TotalQty'
      );

      counters.forEach(counter => {
        if (counter.id === 'CartDrawer-TotalQty') {
          // Special handling for drawer title
          const titleText = counter.textContent.split('(')[0].trim();
          counter.textContent = cart.item_count > 0 
            ? `${titleText} (${cart.item_count})` 
            : titleText;
        } else {
          counter.textContent = cart.item_count;
        }
        if (cart.item_count > 0) {
          counter.style.display = '';
          counter.closest('[data-cart-count-wrapper]')?.classList.remove('hidden');
        }
      });

      // Dispatch for themes that listen
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart }
      }));

    } catch (e) {
      console.log('Could not update cart counter');
    }
  }

  function openCartDrawer() {
    // Get cart-drawer custom element
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer) {
      // First refresh the cart drawer content
      document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));

      // Then open it using the theme's method
      if (!cartDrawer.isOpen) {
        // Small delay to let content refresh first
        setTimeout(() => {
          if (typeof cartDrawer.toggleDrawerClasses === 'function') {
            cartDrawer.toggleDrawerClasses();
          }
        }, 100);
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInstantAdd);
  } else {
    initInstantAdd();
  }

  // Re-initialize on Shopify section events (for theme editor)
  document.addEventListener('shopify:section:load', () => {
    initialized = false;
    initInstantAdd();
  });

})();
